import NepaliDate from 'nepali-date-converter';
import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsListUl } from 'react-icons/bs';
import { FaPlus } from 'react-icons/fa';
import { TiTick } from 'react-icons/ti';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import ReactTable from '../../../../Components/ReactTable/ReactTable';
import Swal from 'sweetalert2';

import {
  createFiscalYear,
  deleteFiscalYear,
  editFiscalYear
} from '../../../../Redux/slices/fiscalyear';
import { clearTable, handleFiscalYearListChange } from '../../../../Redux/slices/table';
import { ErrorMessageHandler, getLastDateOfBSMonth } from '../../../../_helpers/_methods';
import SingleFormInput from '../components/SingleFormInput';

function FiscalYear() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const fiscal_year = useSelector((state) => state.fiscalyear.fiscalyear);
  const [errorMsg, setErrorMsg] = useState(null);
  const lang = useSelector((state) => state.local.local);

  const onDeleteClick = (id) => {
    Swal.fire({
      title: intl.formatMessage({ id: 'are_you_sure' }),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'yes' }),
      cancelButtonText: intl.formatMessage({ id: 'cancel' }),
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteFiscalYear(id, lang));
      }
    });
  };

  const handleActivte = (result) => {
    let data = { ...result, is_active: true };
    dispatch(editFiscalYear(data, lang));
  };
  const columns = useMemo(
    () => [
      { Header: <FormattedMessage id="sn" />, accessor: 'serial_number' },

      {
        Header: <FormattedMessage id="fiscal_year" />,
        accessor: 'fiscal_year'
      },
      {
        Header: <FormattedMessage id="start_date" />,
        accessor: 'start_date'
      },
      {
        Header: <FormattedMessage id="end_date" />,
        accessor: 'end_date'
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions'
      }
    ],
    []
  );

  const data = useMemo(() => {
    if (fiscal_year) {
      let count = 1;
      return fiscal_year.map((result) => {
        let title = <div>{result.title} </div>;
        let startdate = new NepaliDate(new Date(result?.start_date));
        let enddate = new NepaliDate(new Date(result?.end_date));

        let action = result.is_active ? (
          <div className="mx-2">
            <Button variant="success " disabled>
              <TiTick />
              <FormattedMessage id="button.activated" />
            </Button>
          </div>
        ) : (
          <div className="d-flex">
            <div className="mx-2">
              <Button variant="outline-success " onClick={() => handleActivte(result)}>
                <TiTick />
                <FormattedMessage id="button.activate" />
              </Button>
            </div>
            <div className='"mx-2'>
              <Button variant="outline-danger " onClick={() => onDeleteClick(result.id)}>
                <AiOutlineDelete />
              </Button>
            </div>
          </div>
        );
        return {
          serial_number: count++,
          fiscal_year: title,
          start_date:
            lang === 'ne' ? startdate.format('YYYY/MM/DD', 'np') : startdate.format('YYYY/MM/DD'),
          end_date:
            lang === 'ne' ? enddate.format('YYYY/MM/DD', 'np') : enddate.format('YYYY/MM/DD'),
          actions: action
        };
      });
    }
  }, [fiscal_year, lang]);

  const handleFiscalYearFetch = ({ index, pageSize }) => {
    dispatch(handleFiscalYearListChange({ index: index, pageSize: pageSize }));
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const [fiscalYear, setfiscalYear] = useState(false);
  const ShowForm = (check) => {
    check ? setfiscalYear(false) : setfiscalYear(true);
  };
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onBlur', defaultValues: {} });

  const onSubmit = async (data) => {
    try {
      let year = data.title;
      year = new Date(year).getFullYear();
      if (year.length < 4) {
        return setErrorMsg(intl.formatMessage({ id: 'error.fiscal_year_text_type' }));
      }
      let ShrawanMonth = 3;
      let AswinMonth = 2;
      let start_date = new NepaliDate(year, ShrawanMonth, 1).getAD();
      let nextyear = year + 1;
      let lastDateOfAswin = getLastDateOfBSMonth(nextyear, 3);
      let end_date = new NepaliDate(nextyear, AswinMonth, lastDateOfAswin).getAD();

      let body = {
        ...data,
        title: `${year}/${String(nextyear).slice(-2)}`,
        start_date: `${start_date.year}-${start_date.month + 1}-${start_date.date}`,
        end_date: `${end_date.year}-${end_date.month + 1}-${end_date.date}`,
        is_active: false
      };
      setIsLoading(true);
      dispatch(createFiscalYear(body, lang));
      setValue('title', '');
      setIsLoading(false);
      setfiscalYear(false);
    } catch (error) {
      console.log(error, 'errro');
      setIsLoading(false);
      ErrorMessageHandler(error);
    }
  };

  return (
    <div className="card content-section p-3">
      <div className="card-header d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <BsListUl size={35} /> &nbsp;
          <FormattedMessage id="fiscal_year" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button variant="primary" onClick={() => ShowForm(fiscalYear)} disabled={fiscalYear}>
            <FaPlus size={18} />
            <FormattedMessage id="add_new" />
          </Button>
        </div>
      </div>
      <hr />

      <div>
        {fiscalYear && (
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="ps-3">
                <SingleFormInput
                  inputType="text"
                  register={register}
                  max={4}
                  title="fiscal_year"
                  type="fiscal-year"
                  errors={errors}
                  errMsg={errorMsg}
                  setErrMsg={setErrorMsg}
                />
                <div className="d-flex mt-3">
                  <Button
                    variant="danger"
                    onClick={() => {
                      ShowForm(fiscalYear);
                    }}>
                    <FormattedMessage id="button.cancel" />
                  </Button>
                  <SubmitBtn
                    isLoading={isLoading}
                    buttonText={<FormattedMessage id="button.save" />}
                    icon="none"
                  />
                </div>
              </div>
            </form>
          </>
        )}
      </div>
      <div className="">
        <ReactTable data={data} columns={columns} dataFetcher={handleFiscalYearFetch} />
      </div>
    </div>
  );
}

export default FiscalYear;
